import React from 'react'
import { SeatAllCandidates } from '../data'
import {
    FullElectorateInnerRowContainer,
    CandidateText,
    PercentageText,
    VotesText,
    InformationGrid,
    FullElectorateIndicatorContainer,
    FullElectorateIndicator,
    FullElectorateRowContainer,
    FullElectorateHeadingText,
    FullElectorateRowDetailsContainer,
    CandidateDetailsContainer,
} from './FullElectorateRow.styled'
import formatPercentage from '../helpers/GetFormattedPercentage'

export interface FullElectorateCardRowProps {
    candidate: SeatAllCandidates
    isTppState: boolean
}

export const FullElectorateCardRow = ({
    candidate,
    isTppState,
}: FullElectorateCardRowProps) => {
    const color = candidate.partyColor.pale20

    const percent = candidate.currentVotesPercentage

    const BarComponent = (
        <FullElectorateIndicatorContainer>
            <FullElectorateRowDetailsContainer>
                <CandidateDetailsContainer>
                    <FullElectorateHeadingText>
                        {candidate.partyName}
                    </FullElectorateHeadingText>
                    <CandidateText>{candidate.candidateName}</CandidateText>
                </CandidateDetailsContainer>
                <InformationGrid>
                    <div
                        style={{
                            gridColumn: 1,
                        }}
                    >
                        {formatPercentage(candidate.currentVotesPercentage) && (
                            <PercentageText>
                                {`${formatPercentage(
                                    candidate.currentVotesPercentage,
                                )}%`}
                            </PercentageText>
                        )}
                        <VotesText>{candidate.primaryVotes}</VotesText>
                    </div>
                    <div
                        style={{
                            gridColumn: 2,
                        }}
                    >
                        <PercentageText>
                            {isTppState && candidate.swing
                                ? `${formatPercentage(candidate.swing)}%`
                                : '--'}
                        </PercentageText>
                    </div>
                </InformationGrid>
            </FullElectorateRowDetailsContainer>
            <FullElectorateIndicator widthPercent={percent} color={color} />
        </FullElectorateIndicatorContainer>
    )

    return (
        <FullElectorateRowContainer key={candidate.partyCode}>
            <FullElectorateInnerRowContainer>
                {BarComponent}
            </FullElectorateInnerRowContainer>
        </FullElectorateRowContainer>
    )
}
